var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from 'styled-components';
import { jetBlack } from '../../colors';
import { media } from '../..';
import { Wrapper } from '../Header.styles';
export var DesktopWrapper = styled(Wrapper).withConfig({
  displayName: "HeaderDesktopstyles__DesktopWrapper",
  componentId: "sc-4a2e10-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n"])), media.max(768));
export var NavigationLinks = styled.ul.withConfig({
  displayName: "HeaderDesktopstyles__NavigationLinks",
  componentId: "sc-4a2e10-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  list-style-type: none;\n  height: 100%;\n  margin-left: 4.8rem;\n\n  ", " {\n    margin-left: 2.4rem;\n  }\n"], ["\n  display: flex;\n  list-style-type: none;\n  height: 100%;\n  margin-left: 4.8rem;\n\n  ", " {\n    margin-left: 2.4rem;\n  }\n"])), media.max(870));
export var NavigationItem = styled.div.withConfig({
  displayName: "HeaderDesktopstyles__NavigationItem",
  componentId: "sc-4a2e10-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\nposition: relative;\nheight: 100%;\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\n&:not(:last-child) {\n  margin-right: 4.8rem;\n}\n"], ["\nposition: relative;\nheight: 100%;\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\n&:not(:last-child) {\n  margin-right: 4.8rem;\n}\n"])));
export var NavLink = styled.a.withConfig({
  displayName: "HeaderDesktopstyles__NavLink",
  componentId: "sc-4a2e10-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  color: ", ";\n  font-size: 2rem;\n  font-weight: 200;    \n  height: 100%;\n  display: flex;\n  align-items: center;\n"], ["\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  color: ", ";\n  font-size: 2rem;\n  font-weight: 200;    \n  height: 100%;\n  display: flex;\n  align-items: center;\n"])), jetBlack());
export var WidgetItemLabel = styled.span.withConfig({
  displayName: "HeaderDesktopstyles__WidgetItemLabel",
  componentId: "sc-4a2e10-4"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n"])), media.max(870));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;